export default "__VITE_ASSET__pSt5xWR___"